<template>
<div class="vx-col  w-full" :class="wrapclass" v-if="canRenderField(tplkey,fieldsArray ,datatype ,tplsection,fieldName)">
    <div class="form_group mt-datepicker-wrap">
        <label class="form_label">{{label}}<em v-if="checkFieldIsRequired({'key':tplkey,'section':tplsection, 'fieldsArray':fieldsArray, 'required':required })">*</em></label>
<!---
  <VuePhoneNumberInput
   icon-pack="feather" class="w-full no-icon-border"
    :no-example="false" 
    v-validate="required? 'required|'+datatype : datatype " v-bind="translations" :data-vv-as="placeHolder" 
    :name="fieldName+cid" 
     :default-country-code="countrycode" 
     :placeholder="placeHolder" 
     :no-country-selector="false" v-model="value" @input="updateData" ></VuePhoneNumberInput>

    -->
   
  <VuePhoneNumberInput
                  icon-pack="feather"
                  class="w-full no-icon-border"
                  :no-example="false"
                  :data-vv-as="placeHolder"
                  v-validate="checkFieldIsRequired({'key':tplkey,'section':tplsection, 'fieldsArray':fieldsArray, 'required':required })? 'required|'+datatype : datatype " 
                  v-bind="vuePhone.props"
                  :name="fieldName+cid" 
                  :default-country-code="defaultCountryCode" 
                  :placeholder="placeHolder" 
                  :no-country-selector="false"
                  @input="updateData"
                  v-model="value"
                  @update="updatePhone"
                  :preferred-countries="['US', 'IN']"
                  :key="fieldName+cid"
                  :disabled="disableAddress"
                />
                
      <p v-if="errors.has((formscope!=''?formscope+'.':'')+fieldName+cid)" class="text-danger text-sm">{{ errors.first((formscope!=''?formscope+'.':'')+fieldName+cid) }}</p>
      <!-- <template v-else-if="inputCount >2 && !isPhoneValid && value"> -->
        <template v-else-if="!isPhoneValid && value">
      <p   class="text-danger text-sm"  >{{ label ? 'Invalid ' + label : 'Invalid Phone Number'}}</p>
      
       <input v-if="required" type="hidden" v-model="hiddenInputVal" v-validate="'required'" :name="'hiddenInput'+fieldName+cid"  >
      </template>
    </div>
</div>
</template>

<script>

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
    inject: ["parentValidator"],
    props: {
      requestConfiguration:{
        type: Boolean,
        default: true,
      },
        itemArrayIndex:{
            type:Number,
            default:-1
        },
         fieldsArray:Array,
        countrycode:{
            type:String,
            default:'US'
        },
        wrapclass:{
        type:String,
            default:"md:w-1/2"
        },
        datatype:{
            type:String,
            default:""
        },
        tplsection:{
            type: String,
            default: null,
        },
        tplkey:{
            type: String,
            default: null,
        },
         cid: {
            type: String,
            default: null,
        },
        formscope: {
            type: String,
            default: null
        },
        value: null,
        label: {
            type: String,
            default: null,
        },
        fieldName: {
            type: String,
            default: null,
        },
        placeHolder: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disableAddress: {
            type: Boolean,
            default: false,
        },
        category:null,
    },
    data() {
    return {
      defaultCountryCode:'US',
      configDetails:null,
      hiddenInputVal:'',
        // inputCount:0,
        isPhoneValid:true,
        translations: {
                    phoneNumberLabel: this.label,
                },
        vuePhone:{
            props:{
                translations:{
                  phoneNumberLabel: this.label 
                }
            }

        },

    }

    },
    created() {
        this.$validator = this.parentValidator;
       
    },
    
  methods: {
    getGlobalConfigDetails(){
    
            let postData ={}
            let path = 'global-config/details'
             this.$store.dispatch("commonAction", {data:postData,path:path})
           .then((response) =>{   
             this.defaultCountryCode = this.countrycode;            
              if(this.checkProperty(response ,"config" )){
                this.configDetails = this.checkProperty(response ,"config" );

                if(!this.checkProperty(this.configDetails ,"prefillCountryInQuestionnaire" )){
                 // this.defaultCountryCode = '';
                }
               
              }
            })


    },
    updateData() {
        // this.inputCount =this.inputCount+1;
      //  this.isPhoneValid=false;
        
        this.$emit('input', this.value);
       
      
    },
    updatePhone(item) {
        this.isPhoneValid=true;
      if (item.isValid) {
        let phoneCountryCode = {
          countryCode: item.countryCode,
          countryCallingCode: item.countryCallingCode,
          itemArrayIndex:-1,
        };
        phoneCountryCode['itemArrayIndex'] =this.itemArrayIndex;
        this.$emit('updatephoneCountryCode', phoneCountryCode, this.category);
        
      //  this.$emit('input', this.value);
        //this.profileUpdateData.phone = item.nationalNumber;
      }else{
        let phoneCountryCode = {
          countryCode: item.countryCode,
          countryCallingCode: item.countryCallingCode,
          itemArrayIndex:-1,
        };
        phoneCountryCode['itemArrayIndex'] =this.itemArrayIndex;
        this.$emit('updatephoneCountryCode', phoneCountryCode, this.category);
        
        
        this.isPhoneValid=false;
      }
    },
  },
  components: {
    VuePhoneNumberInput
  },
  mounted(){
    if(this.requestConfiguration){
      this.getGlobalConfigDetails();
    }
    
    if(this.countrycode){
      this.defaultCountryCode = this.countrycode;  
    }
   
  }
};
</script>
